/**
 * Shared z-index scheme for portaled modals/sidebars (see layoutSlice's
 * `nextLayer` counter). Every Modal/Sidebar instance's outer portal
 * container gets `BASE + layer * LAYER_STEP` as its z-index, so whichever
 * one opened later always ends up on top — regardless of whether it's a
 * modal or a sidebar, and regardless of the fixed render order in
 * ModalsManager/SidebarsManager.
 */
export const BASE = 2000;
export const LAYER_STEP = 10;
export const getLayerZIndex = (layer) => BASE + (layer !== null && layer !== void 0 ? layer : 0) * LAYER_STEP;
